import { useQuery } from '@tanstack/react-query';
import { getWhatsAppMediaUrl } from '@/services/whatsapp.service';

/**
 * Resolve um storage path para um signed URL (1h), com cache.
 * `enabled` deve ser true apenas quando media_status === 'ready'.
 * staleTime de 50 min garante refetch antes de o signed URL expirar.
 *
 * `canal` determina o bucket: 'app' → 'app-chat-media', qualquer outro
 * (incluindo undefined) → 'whatsapp-media'. O bucket faz parte da queryKey
 * para evitar colisões de cache entre canais.
 */
export function useWhatsAppMediaUrl(
  storagePath: string | null | undefined,
  enabled: boolean,
  canal?: string | null,
) {
  const bucket = canal === 'app' ? 'app-chat-media' : 'whatsapp-media';
  return useQuery({
    queryKey: ['whatsapp-media-url', bucket, storagePath],
    queryFn: () => getWhatsAppMediaUrl(storagePath!, bucket),
    enabled: enabled && !!storagePath,
    staleTime: 50 * 60 * 1000,
  });
}
